// import request from '@/utils/request'
import request from '@/http/request'

export const API_URL_MCH_PAYPASSAGE_LIST = '/api/mch/payPassages/payPassagesInterfaceList' // 查询支付通道列表
// export const API_URL_MCH_PAYPASSAGE = '/api/mch/payPassages' // 支付方式列表

// export const getChannelList = () => {
//   return request.request({
//     url: '/api/mch/payPassages/payPassagesInterfaceList',
//     method: 'get'
//   })
// }

// // /api/mch/payPassages/availablePayInterface/{appId}/{wayCode}
// // 支付接口列表
// export const getPayInterfaceList = (appId, wayCode) => {
//   return request.request({
//     url: `/api/mch/payPassages/availablePayInterface/${appId}/${wayCode}`,
//     method: 'get'
//   })
// }

// 接口文档
// /api/docs
export const getApiDoc = () => {
  return request.request({
    url: '/api/docs',
    method: 'get'
  })
}
